<template>
  <div>
    <v-card class="mx-auto">
      <v-app-bar dark color="primary">
        <v-icon large class="mr-3">assignment_turned_in</v-icon>
        <v-toolbar-title>Task Status</v-toolbar-title>
      </v-app-bar>
    </v-card>

    <v-row v-if="assignedTasks.length > 0" class="mt-4">
      <v-col cols="12" md="3">
        <v-card class="pa-3" color="grey lighten-4">
          <div class="text-h6">Total</div>
          <div class="text-h5 font-weight-bold">{{ statusCounts.total }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-3" color="green lighten-4">
          <div class="text-h6">Active</div>
          <div class="text-h5 font-weight-bold">{{ statusCounts.Active }}</div>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card class="pa-3" color="blue lighten-4">
          <div class="text-h6">Complete</div>
          <div class="text-h5 font-weight-bold">
            {{ statusCounts.Complete }}
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card class="pa-3" color="red lighten-4">
          <div class="text-h6">Terminated</div>
          <div class="text-h5 font-weight-bold">
            {{ statusCounts.Terminated }}
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-autocomplete label="Select Activity" :items="tasks" item-text="name.en" item-value="_id" outlined dense
          class="mt-3" v-model="dataToSend.taskId" />
      </v-col>

      <v-col>
        <v-select label="Select Status" :items="statusItems" item-text="label" item-value="key" outlined dense multiple
          class="mt-3" v-model="dataToSend.status" :disabled="!dataToSend.taskId" @change="handleStatusChange" />
      </v-col>

      <v-col>
        <v-btn color="primary" class="mt-3" @click="getAssignedTasks">Get Assigned Tasks</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Type email to search" single-line
          prepend-inner-icon="mdi-email" hide-details></v-text-field>
      </v-col>
    </v-row>

    <v-data-table v-if="assignedTasks.length > 0" :headers="headers" :items="tasksWithStatusLabel" :search="search" />
  </div>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
const service = new RestResource();

export default {
  data() {
    return {
      tasks: [],
      dataToSend: {
        taskId: undefined,
        status: ["A", "C", "T"],
      },
      statusOptions: [
        { key: "A", label: "Active" },
        { key: "C", label: "Complete" },
        { key: "T", label: "Terminated" },
      ],
      headers: [
        { text: "User Id", value: "userId", sortable: true },
        { text: "Email", value: "email", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Task Type", value: "taskType", sortable: true },
      ],
      assignedTasks: [],
      search: "",
    };
  },

  mounted() {
    this.getTasks();
  },

  methods: {
    getTasks() {
      service.getTasks().then((r) => {
        this.tasks = r.data;
      });
    },

    getAssignedTasks() {
      service.getAssignedTasks(this.dataToSend).then((r) => {
        this.assignedTasks = r.data;
      });
    },
    handleStatusChange(selected) {
      const allKeys = this.statusOptions.map(opt => opt.key);

      if (selected.includes('ALL')) {
        // If "ALL" is toggled and *not all* are selected → select all
        if (this.dataToSend.status.length < allKeys.length) {
          this.dataToSend.status = allKeys;
        } else {
          // If "ALL" is toggled but all are selected → clear all
          this.dataToSend.status = [];
        }
      }
    },
  },
  computed: {
    statusItems() {
      return [{ key: "ALL", label: "Select All" }, ...this.statusOptions];
    },

    tasksWithStatusLabel() {
      const map = { A: "Active", C: "Complete", T: "Terminated" };
      return this.assignedTasks.map((task) => ({
        ...task,
        status: map[task.status] || task.status,
      }));
    },

    statusCounts() {
      const counts = { Active: 0, Complete: 0, Terminated: 0, total: 0 };
      this.assignedTasks.forEach((task) => {
        if (task.status === "A") counts.Active++;
        else if (task.status === "C") counts.Complete++;
        else if (task.status === "T") counts.Terminated++;
      });
      counts.total = counts.Active + counts.Complete + counts.Terminated;
      return counts;
    },
  },
};
</script>
